<template>
  <div v-if="loading" class="loading">
    <spinner size="large" message=""></spinner>
  </div>
</template>
<script>
import Spinner from "vue-simple-spinner";
export default {
  name: "volcan-loading",
  components: {
    Spinner,
  },
  props: ["loading"],
  data: function () {
    return {};
  },
  mounted: function () {},
  computed: {},
  watch: {},
  methods: {},
};
</script>
<style scoped>
.loading {
  position: absolute;
  top: 0;
  left: 0;
  /* bottom: 0%; right: 0%; */
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  /*dim the background*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// components/AdminTools/divers/loading.vue